module.exports = __webpack_public_path__ + "img/loginReg_logo.34b4b273.png";